import React from "react";
import { MenuItem, styled } from "@mui/material";
import Menu from "@mui/material/Menu";
import { useDispatch } from "react-redux";
import copy from "copy-to-clipboard";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import {
  setSnackbarMode,
  setSnackbarTitle,
} from "../../../../../redux/features/settingSlice";

const StyledMenu = styled((props) => <Menu {...props} />)(({ theme }) => ({
  "& .MuiPaper-root": {
    position: "absolute",
    left: "48vw !IMPORTANT",
    fontSize: "18px !IMPORTANT",
    borderRadius: 8,
    marginTop: theme.spacing(1),
    maxWidth: "40vw",
    width: "170px",
    color: "black.main",
    border: "2px solid",
    borderColor: "black.main",
    boxShadow: `0px 4px 0px ${theme.palette.black.main}`,
    "& .MuiMenu-list": {
      padding: "8px 0",
    },
  },
}));

const StyleMenuItem = styled(MenuItem)(({ theme }) => ({
  "&.MuiButtonBase-root": {
    color: theme.palette.black.main,
    fontSize: 18,
    padding: "12px",
    "&:active": { fontWeight: 600 },
  },
}));

const CommentGptOptionBar = ({ anchorEl, setAnchorEl, objCm }) => {
  const dispatch = useDispatch();
  const open = Boolean(anchorEl);

  const handleClose = (e) => {
    e.stopPropagation();
    setAnchorEl(null);
  };

  const handleCopy = () => {
    setAnchorEl(null);
    copy(objCm.text);
    dispatch(setSnackbarMode(true));
    dispatch(setSnackbarTitle("Comment text copied!"));
  };

  return (
    <StyledMenu
      aria-labelledby='cm-menu'
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      <StyleMenuItem onClick={handleCopy}>
        <ContentCopyIcon sx={{ mb: "3px", mr: "8px" }} /> Copy text
      </StyleMenuItem>
    </StyledMenu>
  );
};

export default CommentGptOptionBar;
